import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconName } from './icon-map';
import { IconRegistryService } from './icon-registry.service';

@Component({
  selector: 'app-icon',
  imports: [],
  template: '',
  host: {
    '[class.sm]': 'size === IconSize.SM',
  },
  styles:
    ':host {display: flex; width: 1.5rem;} :host(.sm) {width: 1rem;} svg {width: 100%; height: auto;}',
})
export class IconComponent implements OnInit, OnChanges {
  protected readonly IconSize = IconSize;
  private registry = inject(IconRegistryService);
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() name!: IconName;
  @Input() size: IconSize = IconSize.MD;

  iconContent: SafeHtml = '';

  ngOnInit() {
    this.renderIcon();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['name']) {
      this.renderIcon();
    }
  }

  private renderIcon() {
    const svg = this.registry.getIcon(this.name);
    this.el.nativeElement.innerHTML = svg ?? '';
    if (!svg) {
      console.warn(`Icon "${this.name}" not found in registry`);
    }
  }
}

export enum IconSize {
  SM = 'sm',
  MD = 'md',
}
